const HIGHLIGHT_CLASS = "pdf-text-highlight";
const ORIGINAL_TEXT_ATTR = "data-original-text";

function onlyLetters(s: string): string {
  return s.replace(/[^\p{L}\p{N}]/gu, "").toLowerCase();
}

function escapeHtml(str: string): string {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function strippedPosToOriginal(original: string, strippedPos: number): number {
  let count = 0;
  for (let i = 0; i < original.length; i++) {
    if (/\p{L}|\p{N}/u.test(original[i]!)) {
      if (count === strippedPos) return i;
      count++;
    }
  }
  return original.length;
}

export function clearHighlights(textDivs: HTMLElement[]) {
  for (const div of textDivs) {
    if (div.hasAttribute(ORIGINAL_TEXT_ATTR)) {
      div.textContent = div.getAttribute(ORIGINAL_TEXT_ATTR)!;
      div.removeAttribute(ORIGINAL_TEXT_ATTR);
    }
  }
}

export function highlightQuote(
  textDivs: HTMLElement[],
  quote: string,
): boolean {
  clearHighlights(textDivs);

  const segments = quote
    .split(/\.{3}|…/)
    .map((s) => onlyLetters(s))
    .filter((s) => s.length > 0);

  const divOrigTexts: string[] = [];
  const divStripped: string[] = [];
  const divStartInFull: number[] = [];
  let fullStripped = "";

  for (let i = 0; i < textDivs.length; i++) {
    const orig = textDivs[i].textContent ?? "";
    divOrigTexts.push(orig);
    const stripped = onlyLetters(orig);
    divStripped.push(stripped);
    divStartInFull.push(fullStripped.length);
    fullStripped += stripped;
  }

  const divHighlightRanges = new Map<number, [number, number]>();

  for (const segment of segments) {
    const searchKey = segment.slice(0, 30);
    const matchPos = fullStripped.indexOf(searchKey);
    if (matchPos === -1) continue;
    const matchEnd = matchPos + segment.length;

    for (let i = 0; i < textDivs.length; i++) {
      const divStart = divStartInFull[i]!;
      const divEnd = divStart + divStripped[i]!.length;
      if (matchPos >= divEnd || matchEnd <= divStart) continue;

      const localStart = Math.max(0, matchPos - divStart);
      const localEnd = Math.min(divStripped[i]!.length, matchEnd - divStart);
      divHighlightRanges.set(i, [localStart, localEnd]);
    }
  }

  if (divHighlightRanges.size === 0) return false;

  for (const [idx, [strStart, strEnd]] of divHighlightRanges) {
    const div = textDivs[idx]!;
    const orig = divOrigTexts[idx]!;

    const origStart = strippedPosToOriginal(orig, strStart);
    const origEnd = strippedPosToOriginal(orig, strEnd);

    div.setAttribute(ORIGINAL_TEXT_ATTR, orig);
    div.innerHTML =
      escapeHtml(orig.slice(0, origStart)) +
      `<span class="${HIGHLIGHT_CLASS}">${escapeHtml(orig.slice(origStart, origEnd))}</span>` +
      escapeHtml(orig.slice(origEnd));
  }

  return true;
}
